import styled from 'foundations-theming/utils';
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { View } from 'foundations-components/transitional/components/View';
import { useEffect } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PropTypes from 'prop-types';
import memoizeLast from 'transmute/memoizeLast';
import compose from 'transmute/compose';
import ImmutablePropTypes from 'react-immutable-proptypes';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import emptyFunction from 'react-utils/emptyFunction';

// @ts-expect-error module not typed
import CalleeErrorBoundary from './callee-error/CalleeErrorBoundary';
import CRMEmbeddedMessage from './crm-embedded/components/CRMEmbeddedMessage';
import NoCalleesPrompt from './callee-numbers/components/NoCalleesPrompt';
import CallSettingsNumbers from './callee-numbers/components/CallSettingsNumbers';
// @ts-expect-error module not typed
import EnsureCallingAccess from './calling-appeals/components/EnsureCallingAccess';
import { getData, isSucceeded } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getCallableObjects, getPhoneNumberProperties, getHasAssociatedObjects, getCallablePhoneNumberProperties } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import CallingOnboarding from './callee-numbers/components/CallingOnboarding';
// @ts-expect-error module not typed
import withCalleeOmnibus from './callee-omnibus/hoc/withCalleeOmnibus';
import withCallingAccess from './calling-appeals/hoc/withCallingAccess';
import withWidgetState from './widget-state/hoc/withWidgetState';
// @ts-expect-error module not typed
import withAccessLevelPrefetch from './access-level/hoc/withAccessLevelPrefetch';
import { getIsCRMEmbedded } from './utils/getIsCRMEmbedded';
import { READY, UNINITIALIZED, LOADING } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import preloadCallingWidget from 'calling-global-api/methods/preloadCallingWidget';
import updateCallingReadyState from 'calling-global-api/methods/updateCallingReadyState';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallNumbersPopover__Wrapper",
  componentId: "opgq9e-0"
})(["max-width:615px;"]);
const CallNumbersPopover = props => {
  const hasCallableRecords = memoizeLast(calleesData => {
    const hasAssociatedObjects = getHasAssociatedObjects(calleesData);
    if (hasAssociatedObjects) {
      return true;
    }
    const callableObjects = getCallableObjects(calleesData);
    return callableObjects && callableObjects.some(callableObject => {
      const phoneNumberProperties = getPhoneNumberProperties(callableObject);
      return getCallablePhoneNumberProperties(phoneNumberProperties).size > 0;
    });
  });
  const renderCRMEmbeddedMessage = () => {
    const {
      subjectId,
      objectTypeId
    } = props;
    return /*#__PURE__*/_jsx(CRMEmbeddedMessage, {
      subjectId: subjectId,
      objectTypeId: objectTypeId
    });
  };

  // This used to be buried in the CallSettingsNumber component but needs to be run for NoCalleesPrompt to work properly
  useEffect(() => {
    preloadCallingWidget();
    const callStatusFromWidgetState = getIn(['callStatus'], props.widgetState);
    const shouldSendUpdateReadyState = [READY, UNINITIALIZED, LOADING].includes(callStatusFromWidgetState);
    if (shouldSendUpdateReadyState) {
      updateCallingReadyState({
        subjectId: props.subjectId,
        objectTypeId: props.objectTypeId
      });
    }
  }, [props.objectTypeId, props.widgetState, props.subjectId]);
  const renderNoCalleesMessage = () => {
    const {
      objectTypeId,
      onCallButtonClick = emptyFunction,
      subjectId
    } = props;
    return /*#__PURE__*/_jsx(NoCalleesPrompt, {
      subjectId: Number(subjectId),
      objectTypeId: objectTypeId,
      onAddNumberClick: onCallButtonClick,
      shouldShowAddNumber: true
    });
  };
  const renderCallees = () => {
    const {
      appIdentifier,
      onCallButtonClick,
      subjectId,
      objectTypeId,
      asyncCalleeOmnibus,
      asyncSettingsOmnibus,
      widgetState,
      selectedCallProvider,
      selectedFromNumber,
      selectedCallMethod,
      onSetCallStatus,
      onSetThirdPartyActive,
      gates
    } = props;
    const calleeOmnibusData = getData(asyncCalleeOmnibus);
    const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
    const hasRecords = hasCallableRecords(calleesData);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: !isSucceeded(asyncCalleeOmnibus) || hasRecords ? /*#__PURE__*/_jsx(View, {
        "data-selenium-test": "call-settings-numbers-options",
        children: /*#__PURE__*/_jsx(CallSettingsNumbers, {
          appIdentifier: appIdentifier,
          asyncCalleeOmnibus: asyncCalleeOmnibus,
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          onCallButtonClick: onCallButtonClick,
          subjectId: subjectId,
          objectTypeId: objectTypeId,
          widgetState: widgetState,
          selectedCallProvider: selectedCallProvider,
          selectedFromNumber: selectedFromNumber,
          selectedCallMethod: selectedCallMethod,
          gates: gates,
          onSetCallStatus: onSetCallStatus,
          onSetThirdPartyActive: onSetThirdPartyActive
        })
      }) : renderNoCalleesMessage()
    });
  };
  const {
    appIdentifier,
    scopes,
    gates,
    onCallButtonClick,
    asyncSettingsOmnibus,
    callingAccess
  } = props;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(CalleeErrorBoundary, {
      appName: "CALLING",
      children: /*#__PURE__*/_jsx(EnsureCallingAccess, {
        appIdentifier: appIdentifier,
        useFullWidth: false,
        scopes: scopes,
        callingAccess: callingAccess,
        children: /*#__PURE__*/_jsx(CallingOnboarding, {
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          onRegisterFromPhoneNumber: onCallButtonClick,
          onShowOnboardingIntro: onCallButtonClick,
          onClosePopover: onCallButtonClick,
          gates: gates,
          appIdentifier: appIdentifier,
          children: /*#__PURE__*/_jsx(TFlex, {
            direction: "column",
            children: getIsCRMEmbedded() ? renderCRMEmbeddedMessage() : renderCallees()
          })
        })
      })
    })
  });
};
CallNumbersPopover.proptypes = {
  asyncCalleeOmnibus: RecordPropType('AsyncCalleeOmnibusResult').isRequired,
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  appIdentifier: PropTypes.string.isRequired,
  onCallButtonClick: PropTypes.func,
  scopes: ImmutablePropTypes.map.isRequired,
  limits: ImmutablePropTypes.map.isRequired,
  gates: PropTypes.array.isRequired,
  subjectId: PropTypes.string.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  callingAccess: RecordPropType('CallingAccess').isRequired,
  widgetState: ImmutablePropTypes.map.isRequired,
  selectedCallProvider: RecordPropType('CallingProvider'),
  selectedFromNumber: RecordPropType('FromNumber'),
  selectedCallMethod: PropTypes.string,
  onSetCallStatus: PropTypes.func.isRequired,
  onSetThirdPartyActive: PropTypes.func.isRequired
};
export default compose(withCalleeOmnibus, withCallingAccess, withWidgetState, withAccessLevelPrefetch)(CallNumbersPopover);